import React from 'react';
import PropTypes from 'prop-types';
import * as echarts from 'echarts';

import Throttle from '@scripts/utilities/throttle.js';


class DonutChart extends React.Component {
  constructor(props) {
    super(props);

    this.chart = React.createRef();
    this.chartInstance = undefined;

    this.onResize = Throttle(this.onResize.bind(this), 50);
  }

  onResize() {
    if (this.chartInstance) {
      this.chartInstance.resize();
    }
  }

  updateChartData() {
    var data = this.props.chartData

    var options = {
      tooltip: {
        confine: true,
        trigger: 'item'
      }
    };
    if (this.props.showLegend) {
      options.legend = {
        orient: 'horizontal',
        top: '5%',
        left: 'center',
        data: data,
        textStyle: {
          fontSize: 11,
        },
        padding: [5, 5],
        itemWidth: 15,
        itemHeight: 9
      };
      options.series = [
        {
          name: 'Allocation',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '24',
              fontWeight: 'bold'
            }
          },
          labelLine: { show: false },
          data: data,
          center: ['60%', '80%'],
          width: '80%',
          height: '80%'
        }
      ];
      options.media = [
        {
          query: { minWidth: 550 },
          option: {
            series: [
              {
                center: ['50%', '60%'],
                width: '100%',
                height: '100%',
              }
            ],
            legend: {
              itemWidth: 25,
              itemHeight: 14,
              textStyle: { fontSize: 12 },
              padding: [10, 10],
            }
          }
        },
        {
          query: { minWidth: 720 },
          option: {
            legend: {
              orient: 'vertical',
              left: '70%',
              top: 'center',
              textStyle: { fontSize: 14 },
              itemGap: 15,
              itemWidth: 25,
              itemHeight: 14,
              padding: [15, 15],
            },
            series: [
              {
                center: ['35%', '50%'],
                emphasis: {
                  label: {
                    show: true,
                    fontSize: '30',
                    fontWeight: 'bold'
                  }
                },
                width: 'auto',
                height: 'auto'
              }
            ]
          }
        }
      ];
    } else {
      options.series = [
        {
          name: 'Allocation',
          type: 'pie',
          radius: ['30%', '90%'],
          label: { show: false },
          labelLine: { show: false },
          data: data
        }
      ];
    }

    // allow others to merge the chart option details
    if (this.props.setChartOptions) {
      options = this.props.setChartOptions(options);
    }

    this.chartInstance.setOption(options);
  }

  componentDidMount() {
    this.chartInstance = echarts.init(this.chart.current);

    this.updateChartData();

    // ensure we trigger changes in the chart when the screen resizes
    window.addEventListener('resize', this.onResize);
  }

  componentDidUpdate() {
    this.updateChartData();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  render() {
    return (
      <div className="cs-donut-chart">
        <div className="cs-donut-chart__wrapper">
          <div ref={this.chart} className="cs-donut-chart__chart" />
        </div>
      </div>
    );
  }
}


DonutChart.propTypes = {
  showLegend: PropTypes.bool,
  setChartOptions: PropTypes.func
};

DonutChart.defaultProps = {
  showLegend: true
};


export default DonutChart;

